module.exports = __webpack_public_path__ + "img/chufang.ed35dff6.png";